import { FC, ReactElement } from "react";
import { toTitleCase } from "../../lib/Util";
import { LegacyStatusIcon } from "../common/StatusIcon";
import { ProgressBarWaiting } from "../ui/ProgressBars";

interface ProcessingStatusIconProps {
  status: string;
  finished?: boolean;
  rows?: number;
  large?: boolean;
}

const ProcessingStatusIcon: FC<ProcessingStatusIconProps> = ({ status, large = false }) => {
  // Used in Uploads View - Derived from FlowSink.status
  let icon: ReactElement | null = null;
  if (status === "PENDING") {
    icon = <ProgressBarWaiting status={status} badgeText="Queued" />;
  } else if (status === "STARTED" || status === "PROCESSING") {
    icon = <ProgressBarWaiting status={status} badgeText={toTitleCase(status)} testLabel={"processing-status"} />;
  } else {
    status = status === "SINKING" ? "completed" : status;
    icon = <LegacyStatusIcon status={status} large={large} />;
  }
  return <div data-cy={status}>{icon}</div>;
};

export { ProcessingStatusIcon };
